export default "__VITE_ASSET__C7OKWM3l__"